import React from 'react';

import { Container } from './styles';

const Loading = ({ message = null }) => (
  <Container>
    <div
      style={{
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        padding: '40px 20px',
        borderRadius: '10px',
      }}
      className="spinner-box"
    >
      {message && <h2>{message}</h2>}
      <div className="pulse-container">
        <div className="pulse-bubble pulse-bubble-1" />
        <div className="pulse-bubble pulse-bubble-2" />
        <div className="pulse-bubble pulse-bubble-3" />
      </div>
    </div>
  </Container>
);

export default Loading;
